import { ServiceComplexity, ServiceStatus } from '@prisma/client'
import { z } from "zod"

export const serviceInputSchema = z.object({
  name: z.string().min(3).max(255),
  slug: z.string().min(3).max(255),
  description: z.string().min(3).max(5000).nullable(),
  price: z.number().min(0),
  // Renamed from baseTimeHours in the capacity rewrite (ADR-003).
  // Prisma schema exposes this as Decimal(5,2); transformPrismaModel
  // converts it to a plain number before it hits the client.
  labourHours: z.number().min(0),
  status: z.nativeEnum(ServiceStatus),
  complexity: z.nativeEnum(ServiceComplexity),
  complexityMultiplier: z.number().min(0.1).max(10),
  primaryCategoryId: z.string().min(1).nullable(),
  // Additional data
  additionalData: z.any().optional(),
})

export type ServiceInputItem = z.infer<typeof serviceInputSchema>
